window.formValidation = function formValidation(formCache, response) {
    "use strict";

    var errorField,
        offset;

    // remove traces of errors so form can be updated on a subsequent submit
    formCache.find('.inputError').removeClass('inputError showError');
    formCache.find('.errorWrap').remove();
    formCache.find('.fileError').removeClass('.fileError');
    formCache.prev('.error').remove();
    formCache.prev('.success').remove();


    // if errors add these to the dom
    if (response && response.errors !== null && !$.isArray(response.errors)) {
        if ($.type(response.errors) === 'object' && !$.isEmptyObject(response.errors)) {
            // add errors to relevant fields
            $.each(response.errors, function (name, message) {
                // cache fields with errors
                errorField = formCache.find('input[name="' + name + '"], select[name="' + name + '"], textarea[name="' + name + '"]');

                // check if error corresponds to an input field
                if (errorField.length) {
                    // added error class to input wrap
                    errorField.parent('.inputWrap').addClass('inputError showError');

                    if (errorField.parents('.fileUpload')) {
                        errorField.parents('.fileUpload').addClass('fileError');
                    }

                    errorField.on('blur', function () {
                        if ($(this).val() !== '') {
                            $(this).parent('.inputWrap').removeClass('showError');
                            $(this).parent('.inputWrap').removeClass('inputError');
                            $(this).parent('.inputWrap').find('.errorWrap').slideUp(800);
                            $(this).parents('.fileError').removeClass('fileError');
                        }
                    });

                    // add error message to the dom
                    errorField.parent('.inputWrap').append('<div class="errorWrap"><img src="/sites/petervardy/images/svgs/error-exclamation-solid.svg" alt="Form Error"><span>' + message + '</span></div>');

                    // add error to dom before form
                } else {

                    // check if ther is an error ul already in the dom - if not add one
                    if (!$('ul.error').length) {
                        formCache.before('<ul class="error"></ul>');
                    }

                    formCache.prev('.error').prepend('<li>' + message + '</li>')

                }

                if ($('.overlayBox').length < 1 || formCache.outerHeight() >= $(window).height()) {
                    // scroll to first error
                    offset = formCache.find('.inputError').eq(0).offset();
                    if (offset) {
                        $('html, body').stop(true, true).delay(200).animate({
                            scrollTop: offset.top - 30
                        }, 1000);
                    }
                }

                $(window).trigger('resize');

                formCache.find('#loadingOverlay').fadeOut(function () {
                    $(this).remove();
                });

                if (typeof grecaptcha == 'object') {
                    grecaptcha.reset();
                }
            });
        }

        // if success then move on
    } else {

        if (response && response.success !== null && !$.isArray(response.success)) {

            if (typeof response.success.ga_events != 'undefined') {
                response.success.ga_events.forEach(function (event) {
                    dataLayer.push({'event': event});
                });
            }

            if (response.success.redirect) {
                $(location).attr('href', response.success.redirect);
            } else {

                formCache.before(response.success.message);

                if ($('.removeAfterSubmit').length) {
                    $('.removeAfterSubmit').remove();
                }

                if (response.success.hide_form) {
                    formCache.fadeOut();
                    formCache.find('#loadingOverlay').fadeOut(function () {
                        $(this).remove();
                    });
                }

                if (response.success.hide_cta && $('.js_hideCTA').length) {
                    $('.js_hideCTA').fadeOut(function () {
                        $('.js_successfulAppointment').fadeIn();
                    });
                }
            }
        }
    }
}

window.submitForm = function submitForm(form) {
    "use submit";

    $(document).on('submit', form, function (e) {
        killclick(e);
        var formCache = $(this),
            formData = formCache.serialize(),
            action = formCache.attr('action');

        formCache.prepend('<div id="loadingOverlay"></div>');
        formCache.find('#loadingOverlay').fadeIn();

        formData += '&ajax=true';

        $.ajax({
            type: 'post',
            url: action,
            data: formData,
            context: formCache,
            success: function (response) {
                response = $.parseJSON(response);
                formCache = $(this);
                var form_type = formCache.attr('data-type');
                formValidation(formCache, response);

                var success_message = $(this).parents('div'),
                    offset,
                    off_top;

                offset = success_message.offset();
                off_top = offset.top - 70;

                if ($('.overlayBox').length < 1 || formCache.outerHeight() >= $(window).height()) {
                    $('body,html').stop(true, false).animate({
                        scrollTop: (off_top) - 10
                    }, 800);
                }

                $(window).trigger('resize');
            }
        });
    });
}